import {defaultArt} from '../shared/artwork.js';
export {defaultArt} from '../shared/artwork.js';
function cachedIconSource(station,source){
  if(source&&source===serverIconPath(station))return source;
  try{
    const url=new URL(source);
    if(url.protocol!=='https:'||url.username||url.password)return null;
    return url.href;
  }catch{return null;}
}
export function serverIconPath(station){
  const validId=/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(station?.stationuuid);
  return validId?`/api/stations/${station.stationuuid}/icon`:null;
}
export function artworkFor(station,{failed=false,source=null,adapt=true}={}){
  const favicon=failed?null:cachedIconSource(station,source);
  return {favicon,fallback:defaultArt(station),mode:favicon?(adapt?'adapted':'favicon'):'default'};
}
export function waitForIconRetry(milliseconds,signal){
  return new Promise((resolve,reject)=>{
    if(signal?.aborted){reject(signal.reason);return;}
    const aborted=()=>{clearTimeout(timer);reject(signal.reason);};
    const timer=setTimeout(()=>{signal?.removeEventListener('abort',aborted);resolve();},milliseconds);
    signal?.addEventListener('abort',aborted,{once:true});
  });
}
export async function resolveStationIcon(station,{fetcher=globalThis.fetch,signal,retryDelays=[1000,3000],wait=waitForIconRetry}={}){
  const path=serverIconPath(station);if(!path)throw new Error('Missing station icon ID');
  for(let attempt=0;;attempt++){
    signal?.throwIfAborted();let response;
    try{response=await fetcher(`${path}/source`,{credentials:'same-origin',cache:'no-cache',signal});}
    catch(error){
      if(signal?.aborted||attempt>=retryDelays.length)throw error;
      await wait(retryDelays[attempt],signal);continue;
    }
    if(!response.ok){
      if((response.status>=500||response.status===429)&&attempt<retryDelays.length){await wait(retryDelays[attempt],signal);continue;}
      throw new Error('Station icon unavailable');
    }
    const data=await response.json();
    if(data.fallback===true){
      if(['upstream_unavailable','busy'].includes(data.reason)&&attempt<retryDelays.length){await wait(retryDelays[attempt],signal);continue;}
      return null;
    }
    if(typeof data.url!=='string'||!data.url)throw new Error('Invalid station icon source');
    const source=artworkFor(station,{source:data.url}).favicon;
    if(!source)throw new Error('Invalid station icon source');return source;
  }
}
export function artworkReducer(state,event){
  if(event.attempt!==state.attempt)return state;
  if(event.type==='error')return {attempt:1,loaded:false,source:null};
  if(event.type==='resolved')return {...state,source:event.source};
  if(event.type==='loaded')return {...state,loaded:true};
  return state;
}
